// Central store for wizard inputs (React state + localStorage backup)
import { useEffect, useState, useCallback } from "react";

const STORAGE_KEY = "ariovis_ad_wizard_v1";

export function makeDefaultInputs() {
  return {
    profile: { function: "", objective: "", horizon: "3_6" },
    company: { sector: "", size: "", identities: 500, criticality: "", hourly_downtime_cost: "", hourly_downtime_cost_value: null },
    architecture: {
      forests: 1, domains: 1, dcs: 2, deployment: "hybrid",
      multi_entity: "no", trusts: "no", adfs: "no", adcs: "no",
      entra_connect: "yes", separate_admin_accounts: "partial",
      privileged_accounts: 5, service_accounts: 15, external_admins: 1,
      test_env: "partial", log_retention: "unknown", advanced_audit: "unknown",
    },
    hygiene: { answers: {} },
    monitoring: { answers: {}, weekly_hours_ad: 3 },
    compliance: {
      frameworks: [], audits_per_year: 1, audit_hours: 20, auditor_ad_hoc_hours: 8,
      people_involved: 2, manual_evidence: "unknown", past_findings: "unknown",
      insurance_requirements: "unknown", iam_pam_required: "unknown",
      reports_available: "unknown", continuous_evidence: "unknown",
    },
    roi: {
      hourly_rate: 65, weekly_monitoring_hours: 3, audit_hours_per_year: 20,
      auditor_ad_hoc_hours: 8, investigations_per_year: 4,
      investigation_hours_current: 4, investigation_hours_target: 1,
      incidents_3_years: 0, avg_incident_cost: 100000, annual_incident_probability: 0.15,
      risk_reduction_pct: 0.15, analysis_years: 3, discount_rate: 0.08,
      identity_growth_pct: 0.05, run_cost_annual: 0, internal_mobilization_cost: 0,
      insurance_premium_reduction: 0, weeks_per_year: 47,
    },
  };
}

export function useWizardStore() {
  const [inputs, setInputs] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return { ...makeDefaultInputs(), ...JSON.parse(raw) };
    } catch (e) { /* ignore */ }
    return makeDefaultInputs();
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(inputs)); } catch (e) { /* ignore */ }
  }, [inputs]);

  const updateSection = useCallback((section, patch) => {
    setInputs((prev) => ({ ...prev, [section]: { ...prev[section], ...patch } }));
  }, []);

  const reset = useCallback(() => {
    setInputs(makeDefaultInputs());
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) { /* ignore */ }
  }, []);

  const replace = useCallback((next) => setInputs(next), []);

  return { inputs, updateSection, reset, replace, setInputs };
}
